export default "__VITE_ASSET__BI$j1qQE__"